import {StorageBase} from "../storage/storageEx"
import config from "../config/settings"
import {ixsIsObject} from "./functions"
// import moment from "moment"
//import type {State as AppState} from "app/flowTypes";
// import {KEY_AUTH_TOKEN}` from "auth/constants";
import {USER_DATA, DOCTOR} from "../config/constants"

import GlobalStore from "../store/GlobalStore"

import {useState, useEffect, useRef} from "react"

// import UIStore from "../../modules/stores/UIStore"

//Získa objekt aktuálne prihláseného používateľa
// export const getUser = () => Storage.getItem(USER_DATA)
export const getUser = () => StorageBase.getObjectByKey(USER_DATA)
export const getDoctor = () => StorageBase.getObjectByKey(DOCTOR) //Získa ID aktuálne zvoleného oddelenie používateľa (inak nazvané PROVIDER ID)

//Ziskanie clientId
export const getClientID = () => {
	if (isSafe(getUser()) && isSafe(getUser().relships)) {
		return getUser().relships.filter((x) => x._type == "Entity.Data.Client")[0]._id
	}
}

export const openWindowWithPost = (url, data) => {
	let form = document.createElement("form")
	form.target = "_blank"
	form.method = "POST"
	form.action = url
	form.style.display = "none"

	for (let key in data) {
		const value = data[key]

		if (ixsIsObject(value)) {
			for (let k in value) {
				let input = createHiddenInput(k, value[k])
				form.appendChild(input)
			}
		} else {
			let input = createHiddenInput(key, value)
			form.appendChild(input)
		}
	}
	document.body.appendChild(form)
	form.submit()
	document.body.removeChild(form)
}

export const createHiddenInput = (key, value) => {
	let input = document.createElement("input")
	input.type = "hidden"
	input.name = key
	input.value = value
	return input
}

export const printMultiReport = (multiValues, streamCallback, splitMultiplePages = false, format = null) => {
	const company = getUserCompanyInfo()
	const customIdentifier = company && company.identifier ? parseInt(company.identifier) : null

	let cnt = 0
	let cntMultiple = 0
	let resValues = {}
	let resValuesMultiple = {}

	multiValues.map((mv) => {
		const template = mv.template

		//Zisžujeme či rozdeľujeme na viacstranové a jednostranové
		if (!splitMultiplePages || !mv.multiplePages) {
			cnt++
			for (let v in mv.values) {
				resValues[`${cnt}$${template}$${v}$${customIdentifier}`] = mv.values[v]
			}
		} else {
			cntMultiple++
			for (let v in mv.values) {
				resValuesMultiple[`${cntMultiple}$${template}$${v}$${customIdentifier}`] = mv.values[v]
			}
		}
	})

	if (Object.keys(resValues).length !== 0) {
		const requestData = {
			_multi: true,
			_stream: streamCallback ? true : false,
			_format: format,
			values: resValues
		}
		printMPDF(streamCallback, requestData)
	}

	//Viacstranové na samostaný tab
	if (Object.keys(resValuesMultiple).length !== 0) {
		const requestDataMulti = {
			_multi: true,
			_stream: streamCallback ? true : false,
			_format: format,
			values: resValuesMultiple
		}
		printMPDF(streamCallback, requestDataMulti)
	}
}

export const printMPDF = (streamCallback, requestData) => {
	if (streamCallback) {
		fetch(config.MPDF_API, {
			method: "POST",
			headers: {
				"Content-Type": "application/json"
			},
			body: JSON.stringify(requestData)
		})
			.then((response) => response.blob())
			.then((blob) => streamCallback(blob))
	} else {
		openWindowWithPost(config.MPDF_API, requestData)
	}
}

//Získa ID defaultnej služby
export const getDefaultProvidedServiceID = () => {
	const selectedOrgUnit = getSelectedOrgUnit()
	return selectedOrgUnit ? selectedOrgUnit.default_provided_service_id : null
}

//Získa ID personnel aktuálne prihláseného používateľa
export const getUserPersonnelID = () => {
	const currentUser = getUser()
	if (currentUser) {
		const personnel = currentUser.relships.find((relship) => {
			return relship._type === "EHR.Data.Entity.Personnel"
		})
		return personnel ? personnel._id : null
	}
	return null
}

//Získa oddelenia prihláseného používateľa
export const getUserPersonnelOrgUnits = () => {
	if (GlobalStore.orgunits) {
		return GlobalStore.orgunits
	}
}

//Získa aktuálne zvolené oddelenie prihláseného používateľa (inak nazvané PROVIDER)
export const getSelectedOrgUnit = () => {
	if (GlobalStore.orgunits) {
		return GlobalStore.orgunits.find((ou) => ou._id === GlobalStore.orgunitsId)
	}
}

//Získa ID aktuálne zvoleného oddelenie používateľa (inak nazvané PROVIDER ID)
export const getSelectedOrgUnitID = () => {
	if (GlobalStore.orgunitsId) {
		return GlobalStore.orgunitsId
	}
}

//Získa zdroj aktuálne zvoleného oddelenia prihláseného používateľa
export const getSelectedOrgUnitResourceID = () => {
	if (GlobalStore.orgunitsResourceId) {
		return GlobalStore.orgunitsResourceId
	}
}

//Vráti objekt s informáciami o doktorovi
export const getUserDoctorInfo = () => {
	const currentUser = getUser()

	if (isSafe(currentUser)) {
		const personnel = currentUser.relships.find((relship) => relship._type === "EHR.Data.Entity.Personnel")

		if (personnel) {
			let code = null
			let expertise = null
			let name = null
			let loginemail = null
			let selectedContact = null
			let selectedAddress = null

			//Kód lekára a odbornosť získavame z aktuálneho zvoleného orgunit
			const selectedOrgUnit = getSelectedOrgUnit()
			if (selectedOrgUnit) {
				// selectedExpertise = personnel.expertises ? personnel.expertises.find(ex => ex._id === selectedOrgUnit.personnel_expertise_id) : null;
				selectedContact = selectedOrgUnit.contacts.find((c) => c.contact_type._id === "business")

				//Primárne doťahujeme adresu sídla, ak ju nemáme tak doťahujeme adresu označenú ako primárnu
				selectedAddress = selectedOrgUnit.addresses.find((a) => a.type && a.type._id === "OA")
				if (!selectedAddress) {
					selectedAddress = selectedOrgUnit.addresses.find((a) => a.primary)
				}
				code = selectedOrgUnit.doctor_code

				expertise = {
					id: selectedOrgUnit.personnel_expertise_id,
					cl_id: selectedOrgUnit.personnel_expertise_cl_id,
					code: selectedOrgUnit.personnel_expertise_cl_code,
					code_ext: selectedOrgUnit.personnel_expertise_cl_code_ext,
					name_ext: selectedOrgUnit.personnel_expertise_cl_name_ext,
					jruz_id: selectedOrgUnit.personnel_expertise_jruz_id
				}

				//Zmenilo sa API pre login a v objekte personnel.expertises uz tieto informacie niesu
				// expertise = (selectedExpertise && selectedExpertise.expertise) ? {
				//   code: selectedExpertise.expertise.code_ext,
				//   name: selectedExpertise.expertise.name_ext,
				//   fullname: `${selectedExpertise.expertise.code_ext} - ${selectedExpertise.expertise.name_ext}`,
				//   id: selectedExpertise.expertise._id
				// } : null;
			}

			name = currentUser.person ? currentUser.person.full_name : null
			loginemail = currentUser.user.email

			return {
				id: personnel._id,
				code: code,
				expertise: expertise,
				name: name,
				loginemail: loginemail,
				address: selectedAddress,
				contact: selectedContact
			}
		}
	}
	return null
}

// Vráti objekt s informáciami o poskytovateľovi
export const getUserCompanyInfo = () => {
	const company = getUser().company
	return company ? {...company, id: company._id} : null
}

// Hash objektu do stringu
export const hashCode = (obj) => {
	// let result = ""
	// if (Array.isArray(str)) {
	// 	result = str.join("#")
	// }
	// return str.split("").reduce((prevHash, currVal) => ((prevHash << 5) - prevHash + currVal.charCodeAt(0)) | 0, 0)
	let hashString = ""
	if (ixsIsObject(obj)) {
		hashString = JSON.stringify(obj)
	}
	return hashString
}

//Získa zoznam pristupov uzivatela
export const getUserAccessList = () => {
	const user = getUser()
	if (isSafe(user)) return user.sec_access
	else return []
}

//Získa riadok z pristupov pouzivatela podla mena a typu
export const getUserAccessRights = (name, type = "") => {
	const sec_access = getUserAccessList()
	if (isSafe(sec_access) && isSafe(sec_access.resources))
		return sec_access.resources.find((res) => res.name.includes(name) && res.name.includes(type))
	else return null
}

// Vlozi pomocku na miesto kde je kurzor
export const handleInsertHelpersIntoTextArea = (form, areaName, cursor, dataToInsert) => {
	const srcVal = form
		.$(areaName)
		.value.toString()
		.replace(/&[^;]*;/g, " ")
	let pastePosition = 0

	const textCursor = cursor

	let modifSrcVal = srcVal
	let removedLength = 0
	while (modifSrcVal.indexOf("<") < textCursor) {
		const actualSrcLength = modifSrcVal.length
		if (modifSrcVal.indexOf("<") == modifSrcVal.indexOf("<p><br></p>")) {
			modifSrcVal = modifSrcVal.replace("<p><br></p>", " ")
		} else if (modifSrcVal.indexOf("<") == modifSrcVal.indexOf("</p>") && modifSrcVal.indexOf("</p>") < textCursor) {
			modifSrcVal = modifSrcVal.replace(/<[^>]*>/, " ")
		} else {
			modifSrcVal = modifSrcVal.replace(/<[^>]*>/, "")
		}

		removedLength += actualSrcLength - modifSrcVal.length
	}

	pastePosition = removedLength + textCursor

	form.$(areaName).value =
		form.$(areaName).value.slice(0, pastePosition) + dataToInsert + form.$(areaName).value.slice(pastePosition)
}

// custom hook for using timer
export const useInterval = (callback, delay) => {
	const savedCallback = useRef()

	useEffect(() => {
		savedCallback.current = callback
	}, [callback])

	useEffect(() => {
		function tick() {
			savedCallback.current()
		}
		if (delay !== null) {
			let id = setInterval(tick, delay)
			return () => clearInterval(id)
		}
	}, [delay])
}

export const mergeObj = (target, source) => {
	for (const key of Object.keys(source)) {
		if (source[key] instanceof Object && key in target) Object.assign(source[key], mergeObj(target[key], source[key]))
	}
	Object.assign(target || {}, source)
	return target
}

export const useMergeState = (initialState) => {
	const [state, setState] = useState(initialState)
	const setMergedState = (newState) => setState((prevState) => mergeObj(prevState, newState))
	return [state, setMergedState]
}

export const getFieldIdentifier = (field, additional = "") => {
	let customClassName = additional
	if (field) {
		const fieldName = field.name || field.key
		customClassName = customClassName === "" ? fieldName : `${customClassName} ${fieldName}`
	}
	return customClassName
}

export const getFullDataFromOptimized = (data) => {
	if (isSafe(data) && Array.isArray(data) && data.length) {
		data.forEach((row) => {
			Object.keys(row).forEach((rowKey) => {
				let rowKeyVal = row[rowKey]
				if (
					ixsIsObject(rowKeyVal) &&
					((Object.keys(rowKeyVal).length == 2 &&
						Object.keys(rowKeyVal).every((objKey) => objKey == "_type" || objKey == "_id")) ||
						(Object.keys(rowKeyVal).length == 3 &&
							Object.keys(rowKeyVal).every(
								(objKey) => objKey == "_type" || objKey == "_id" || (objKey == "_ref" && rowKeyVal["_ref"] == true)
							)))
				) {
					const fullDataRow = data.find(
						(dataRow) =>
							isSafe(dataRow[rowKey]) &&
							isNotEmpty(dataRow[rowKey]._id) &&
							dataRow[rowKey]._id == rowKeyVal._id &&
							Object.keys(dataRow[rowKey]).length > 3
					)
					if (isSafe(fullDataRow)) {
						row[rowKey] = fullDataRow[rowKey]
					}
				}
			})
		})
	}

	return data
}
